import { Box, Typography } from '@mui/material';

import Modal from 'src/components/customModal';
import modals from 'src/constants/modals';
import { styledMainTitle } from 'src/components/InviteModal/styles';
import { ActionButtons } from 'src/layouts/main/styles';
import { handleCloseModal } from 'src/utils/propertyHelpers';
import { useState } from 'react';
import {
	getTransactionOverviewThunk,
	getTransactionParticipantsThunk,
	getTransactionSummaryThunk,
	selectTransactionOverview,
	selectTransactionTitle,
} from 'src/redux/slices/transaction';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { dispatch, useSelector } from 'src/redux/store';
import { openModal, selectModal } from 'src/redux/slices/modal';
import { PropertyTitle } from 'src/types';
import { labelByPropertyTitleTenure } from 'src/constants/title';
import { parseStringToJson } from 'src/utils/strings';
import { RESPONSE_CODES } from 'src/constants';

const Content = () => {
	const { enqueueSnackbar } = useSnackbar();
	const transaction = useSelector(selectTransactionOverview);
	const { payload } = useSelector(selectModal<PropertyTitle>);
	const [isLoading, setIsLoading] = useState(false);

	const handleConfirm = (withDataExtraction: boolean) => async () => {
		try {
			setIsLoading(true);

			await dispatch(selectTransactionTitle({ title: payload, withDataExtraction })).unwrap();

			enqueueSnackbar('Transaction title successfully selected!');
			dispatch(getTransactionSummaryThunk({ id: transaction.id, withLoading: true }));
			dispatch(getTransactionParticipantsThunk({ id: transaction.id, withLoading: true }));
			dispatch(getTransactionOverviewThunk({ id: transaction.id }));
			handleCloseModal();
		} catch (e) {
			console.log(e);

			if (e instanceof Error) {
				const response = parseStringToJson(e.message);

				if (typeof response === 'string') {
					enqueueSnackbar(response, { variant: 'error' });
				} else if (response?.code) {
					switch (response?.code) {
						case RESPONSE_CODES.HMLR.TITLE_PENDING_APPLICATION:
							dispatch(openModal({ name: modals.forceTitleAssignment, payload }));
							break;
						default:
							break;
					}
				}
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Box>
			<Typography sx={styledMainTitle} pt={0}>
				CONFIRM TITLE
			</Typography>
			<Typography>
				You have selected{' '}
				<b>
					{payload.number} ({labelByPropertyTitleTenure[payload.tenure]})
				</b>
				.
				<br />
				<br />
				<b>Option 1</b>: Assign title number and tenure (<b>FREE</b>)
				<br />
				<b>Option 2</b>: Assign title number and tenure, list proprietors, and download register extracts (
				<b>£14 charge - included in conveyancing fees</b>)
			</Typography>
			<ActionButtons mt='20px' display='flex' justifyContent='flex-end' gap='20px !important'>
				<LoadingButton variant='outlined' size='large' onClick={handleCloseModal} loading={isLoading}>
					Back
				</LoadingButton>
				<LoadingButton variant='contained' size='large' loading={isLoading} onClick={handleConfirm(false)}>
					Assign
				</LoadingButton>
				<LoadingButton variant='contained' size='large' loading={isLoading} onClick={handleConfirm(true)}>
					Assign & Download
				</LoadingButton>
			</ActionButtons>
		</Box>
	);
};

const TitleAssignmentConfirmationModal = () => (
	<Modal name={modals.titleAssignmentConfirmation} cardSx={{ overflow: 'visible', maxWidth: '700px' }}>
		<Content />
	</Modal>
);

export default TitleAssignmentConfirmationModal;
